<template>
  <div class="alturaMin">
      <h3 id="premiosTop" class="d-block center my-5" style="color: black">Escolha o seu benefício</h3>

    <!-- CATEGORIAS MOBILE -->
    <div class="col s12">
      <a
        href="#"
        data-target="mobile-categoria"
        class="btn blue waves-effect waves-blue mb-5 sidenav-trigger mx-auto d-block d-sm-none"
        style="border-radius: 30px; max-width: 130px"
      >Categorias</a>
    </div>

    <div class="categoria">
      <ul class="collapsible sidenav" id="mobile-categoria">
        <h6 id="title-categ">CATEGORIAS</h6>

        <li v-for="(categ, i) in categories" :key="i" :id="'categg' + i">
          <div class="collapsible-header" @click="getPrizesByCateg(categ, null, true)">
            {{categ.categoria}}
            <i
              v-show="categ.subCategories"
              class="material-icons arrow"
            >arrow_right</i>
          </div>
          <div class="collapsible-body py-0">
            <p
              v-for="(sub, j) in categ.subCategories"
              :key="'k'+j"
              @click="getPrizesByCateg(categ, sub.id, true)"
            >
              <span>{{sub.categoria}}</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <!-- /CATEGORIAS MOBILE -->

    <div class="row m-0 container mb-0" style="max-width: 100%">
      <!-- CATEGORIAS -->
      <div class="col l3 m4 d-none d-sm-block">
        <h6 id="title-categ" class="categoria">CATEGORIAS</h6>
        <div class="categoria">
          <a href="#premiosTop">
            <ul class="collapsible">
              <li v-for="(categ, i) in categories" :key="i" :id="'categg' + i">
                <div class="collapsible-header" @click="getPrizesByCateg(categ, null, true)">
                  {{categ.categoria}}
                  <i
                    v-show="categ.subCategories"
                    class="material-icons arrow"
                  >arrow_right</i>
                </div>
                <div class="collapsible-body py-0">
                  <p
                    v-for="(sub, j) in categ.subCategories"
                    :key="'k'+j"
                    @click="getPrizesByCateg(categ, sub.id, true)"
                  >
                    <span>{{sub.categoria}}</span>
                  </p>
                </div>
              </li>
            </ul>
          </a>
        </div>
        <!-- /CATEGORIAS -->

        <!-- PROPAGANDA -->
        <div id="propagandas" class="propaganda">
          <carousel :per-page="1" :autoplay="true" :loop="true" :autoplayTimeout="5000">
            <slide class="carousel-item" v-for="(banner, key) in propagandas" :key="key">
              <a :href="banner.link" target="_blank">
                <img class="responsive-img d-block mx-auto" :src="banner.imagem" />
              </a>
            </slide>
          </carousel>
        </div>
        <!-- /PROPAGANDA -->
      </div>

      <!-- PREMIOS -->
      <div id="premios" class="col s12 m8 l9">
        <div v-show="prizesLoading" class="col s12 m8 l9 position-absolute">
          <Loading />
        </div>

        <transition name="slide-fade" mode="out-in">
          <div v-show="prizes.length>0 && !prizesLoading" class="row">
            <div v-for="(prize,key) in prizes" :key="key" class="col s12 m6 xl4">
              <div class="card-premio" @click="toPremio('/premio/'+prize.id)">
                <div class="body">
                  <img class="icon-pres" src="../../assets/img/ícone1.png" alt />
                  <img class="img-premio" :src="prize.foto1" />
                </div>
                <p class="nome-premio">{{prize.titulo}}</p>
                <div v-if="client && prize.titulo != 'ANIVERSÁRIO'">
                  <p
                    class="pontos-premio"
                    v-if="obj.habilitar_pontuacao_inteira"
                  >{{parseInt(prize.valor).toLocaleString('pt-BR')}} {{(obj.moeda.toLowerCase()!='points') ? obj.moeda : 'Pontos'}}</p>
                  <p
                    class="pontos-premio"
                    v-else
                  >{{parseFloat(prize.valor).toFixed(2).replace('.',',').toLocaleString('pt-BR')}} {{(obj.moeda.toLowerCase()!='points') ? obj.moeda : 'Pontos'}}</p>
                </div>
                <router-link
                  :to="'/premio/'+prize.id"
                  class="waves-effect waves-light btn-resgatar"
                >RESGATAR</router-link>
              </div>
            </div>
          </div>
        </transition>

        <div
          v-show="prizes.length == 0 && !prizesLoading"
          class="alert center"
          role="alert"
        >Nenhum prêmio encontrado!</div>
      </div>
      <!-- /PREMIOS -->

      <!-- PAGINAÇÃO -->
      <div class="row">
        <div v-if="!mudarCateg" id="pagination" class="col s12 m8 l9">
          <a href="#premiosTop">
            <paginate
              id="inline"
              :page-count="pagination"
              :click-handler="paginate"
              :prev-text="'Anterior'"
              :next-text="'Próximo'"
              :page-class="'inline'"
              v-if="pagination>1"
              v-model="page"
              class="pagination"
            ></paginate>
          </a>
        </div>
      </div>
      <!-- /PAGINAÇÃO -->
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { Donuz } from "donuz-js/Donuz";
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide,
    VuejsPaginate: "paginate",
    Loading
  },
  data() {
    return {
      obj: {},
      response: {},
      prizes: [],
      categories: [],
      categoriaAtual: {},
      propagandas: [],
      banners: [],
      mudarCateg: false,
      pagination: 0,
      prizesLoading: true,
      hide: false,
      adminLoad: true,
      client: false,
      forgotPassword: null,
      email: "",
      cpf: "",
      password: "",
      pesquisa: "",
      page: 1
    };
  },
  updated() {
    M.Collapsible.init(document.querySelectorAll(".collapsible"));
    M.Sidenav.init(document.querySelectorAll(".sidenav"));
  },
  async created() {
    this.obj = await this.getAdmins();
    this.obj = this.obj.estabelecimentos[0];

    this.obj.banners.forEach(element => {
      if (element.descricao.includes("propaganda")) {
        this.propagandas.push(element);
      } else {
        this.banners.push(element);
      }
    });

    this.adminLoad = false;

    this.response = await Donuz.category.getCategories();

    this.response.categorias.sort((a, b) => {
      if (a.categoria.toLowerCase() > b.categoria.toLowerCase()) {
        return 1;
      }
      return -1;
    });

    if (this.response.status == 200) {
      this.categories = this.response.categorias;
      for (let i = 0; i < this.categories.length; i++) {
        this.response = await Donuz.category.getSubCategories(
          this.categories[i].id
        );
        if (this.response.status == 200) {
          this.categories[i].subCategories = this.response.categorias;
        }
      }
    }

    this.categories.forEach(el => {
      if (el.subCategories) {
        el.subCategories.sort((c, d) => {
          if (c.categoria.toLowerCase() > d.categoria.toLowerCase()) {
            return 1;
          }
          return -1;
        });
      }
    });

    if (!localStorage.estadoHome) {
      this.response = await Donuz.prizes.getRewardByTag(
        "destaque",
        this.obj.ordem_exibicao
      );

      if (this.response.status == 200) {
        this.prizes = this.response.premios;
        this.prizesLoading = false;
      }
      if (this.response.status == 410) {
        this.prizesLoading = false;
      }
    } else {
      var obj = JSON.parse(localStorage.estadoHome);
      this.prizes = obj.prizes;

      if (obj.categoria.id) {
        this.categoriaAtual.id = obj.categoria.id;
        this.categoriaAtual.subcateg = obj.categoria.subcateg;
      }

      if (obj.pesquisa) {
        this.pesquisa = obj.pesquisa;
      }

      if (obj.registros) {
        this.registros = obj.registros;
      }

      this.pagination = parseInt(this.registros / this.obj.premios_por_pagina);
      if (obj.registros % obj.premios_por_pagina != 0) {
        this.pagination++;
      }

      if (obj.page) {
        this.page = obj.page;
      }

      this.prizesLoading = false;
    }

    if (sessionStorage.getItem(btoa("cliente")) != null) {
      this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
    }
  },
  methods: {
    paginate: async function(page) {
      this.page = page;

      this.prizesLoading = true;
      let per_page = this.obj.premios_por_pagina;
      let max = per_page;

      if (this.categoriaAtual.id) {
        this.response = await Donuz.prizes.getRewardByCategory(
          this.categoriaAtual.id,
          this.categoriaAtual.subcateg,
          null,
          this.obj.ordem_exibicao,
          (page - 1) * per_page + "," + max
        );
        if (this.response.status == 200) {
          this.prizes = this.response.premios;
          this.prizesLoading = false;
        }

        if (Object.keys(this.categoriaAtual).length == 0) {
          let response = await Donuz.prizes.getRewards(
            this.obj.ordem_exibicao,
            (page - 1) * per_page + "," + max
          );
          if (response.status == 200) {
            this.prizes = response.premios;
            this.prizesLoading = false;
          } else {
            this.prizes = [];
          }
        } else {
          this.prizesLoading = true;
          this.response = await Donuz.prizes.getRewardByCategory(
            this.categoriaAtual.id,
            this.categoriaAtual.subcateg,
            null,
            this.obj.ordem_exibicao,
            (page - 1) * per_page + "," + max
          );
          if (this.response.status == 200) {
            this.prizes = this.response.premios;
            localStorage.estadoHome = JSON.stringify({
              prizes: this.prizes,
              categoria: {
                id: this.categoriaAtual.subcateg,
                subcateg: this.categoriaAtual.subcateg
              },
              registros: this.response.registros,
              premios_por_pagina: this.obj.premios_por_pagina,
              page: this.page
            });
          } else {
            this.prizes = [];
          }

          this.pagination = parseInt(
            this.response.registros / this.obj.premios_por_pagina
          );
          if (this.response.registros % this.obj.premios_por_pagina != 0) {
            this.pagination++;
          }

          this.prizesLoading = false;
        }
      } else if (this.pesquisa && this.pesquisa != "") {
        this.prizesLoading = true;
        this.response = await Donuz.prizes.searchRewards(
          this.pesquisa,
          null,
          null,
          this.obj.ordem_exibicao,
          (page - 1) * per_page + "," + max
        );
        if (this.response.status == 200) {
          this.prizes = this.response.premios;
          localStorage.estadoHome = JSON.stringify({
            prizes: this.prizes,
            registros: this.response.registros,
            categoria: { id: null, subcateg: null },
            pesquisa: this.pesquisa,
            page: this.page
          });
        } else {
          this.prizes = [];
        }
        this.pagination = parseInt(
          this.response.registros / this.obj.premios_por_pagina
        );
        if (this.response.registros % this.obj.premios_por_pagina != 0) {
          this.pagination++;
        }
        this.prizesLoading = false;
      }
    },
    async searchRewards() {
      this.page = 1;

      if (this.pesquisa == "") {
        return;
      }

      this.mudarCateg = true;

      this.prizesLoading = true;
      this.response = await Donuz.prizes.searchRewards(
        this.pesquisa,
        null,
        null,
        this.obj.ordem_exibicao,
        this.obj.premios_por_pagina
      );
      if (this.response.status == 200) {
        this.prizes = this.response.premios;
        localStorage.estadoHome = JSON.stringify({
          prizes: this.prizes,
          registros: this.response.registros,
          categoria: { id: null, subcateg: null },
          pesquisa: this.pesquisa
        });
      } else {
        this.prizes = [];
      }
      this.pagination = parseInt(
        this.response.registros / this.obj.premios_por_pagina
      );
      if (this.response.registros % this.obj.premios_por_pagina != 0) {
        this.pagination++;
      }
      this.categoriaAtual.id = null;
      this.categoriaAtual.subCateg = null;

      this.mudarCateg = false;
      this.prizesLoading = false;
    },
    getPrizesByCateg: async function(
      categ,
      subcateg = null,
      mudarCate = false
    ) {
      if (subcateg == null) {
        if (categ.subCategories) {
          return;
        }
      }

      var id = categ.id;
      this.page = 1;
      this.categoriaAtual.id = id;
      this.categoriaAtual.subcateg = subcateg;

      if (mudarCate) {
        this.mudarCateg = true;
      }

      this.prizesLoading = true;
      this.response = await Donuz.prizes.getRewardByCategory(
        id,
        subcateg,
        null,
        this.obj.ordem_exibicao,
        this.obj.premios_por_pagina
      );
      if (this.response.status == 200) {
        this.prizes = this.response.premios;
        localStorage.estadoHome = JSON.stringify({
          prizes: this.prizes,
          categoria: { id, subcateg },
          registros: this.response.registros,
          premios_por_pagina: this.obj.premios_por_pagina
        });
      } else {
        this.prizes = [];
      }
      this.pagination = parseInt(
        this.response.registros / this.obj.premios_por_pagina
      );
      if (this.response.registros % this.obj.premios_por_pagina != 0) {
        this.pagination++;
      }
      this.pesquisa = null;

      this.prizesLoading = false;
      this.mudarCateg = false;
    },
    change: function(id) {
      let element = document.getElementsByClassName("btn-resgate")[id];
      if (element.classList.contains("hide")) {
        element.classList.remove("hide");
      } else {
        element.classList.add("hide");
      }
    },
    submit: async function(e) {
      e.preventDefault();
      let result = await Donuz.customer.signIn(this.cpf, this.password);
      if (result.status == 200) {
        M.toast({ html: result.mensagem, classes: "green" });
        let client = result.clientes[0];
        let saldo = await Donuz.balance.getCustomerBalance(result.token);
        client.saldo = parseFloat(saldo.saldo)
          .toFixed(2)
          .replace(".", ",");
        sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(client)));
        sessionStorage.setItem(btoa("tokenCliente"), result.token);
        location.href = this.baseUrl;
      } else {
        M.toast({ html: result.mensagem, classes: "red" });
      }
    },
    forgot: async function(e) {
      e.preventDefault();
      let result = await Donuz.customer.forgotPassword(this.email);
      if (result.status == 200) {
        M.toast({ html: result.mensagem, classes: "green" });
      } else {
        M.toast({ html: result.mensagem, classes: "red" });
      }
    },
    open: function() {
      var elem = document.getElementById("modal1");
      var instance = M.Modal.getInstance(elem);
      instance.open();
    },
    scroll(aux) {
      if (aux) {
        document.getElementById("row-scroll").scrollLeft += 295;
      } else {
        document.getElementById("row-scroll").scrollLeft -= 295;
      }
    },
    toPremio(rota) {
      this.$router.push(rota);
    }
  }
};
</script>

<style lang="scss" scoped>
.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}

.alert {
  position: relative;
  font-size: 12pt;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #383d41;
  background-color: #ececec;
}

.col {
  margin-left: 0 !important;
}

#pagination {
  margin-left: auto !important;
  text-align: center;
  margin-top: -50px;
}

.pagination {
  margin: 0;
}

#premios{
  min-height: 415px;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.negrito1 {
  font-weight: 600;
}

.arrow {
  font-size: 15pt;
  position: absolute;
  right: 5px;
  top: 15px;
  color: black;
}

#title-categ {
  color: #333333;
  font-weight: bolder;
  font-family: gotham;
}

ul:not(.browser-default) {
  list-style-type: none;
}

ul:not(.browser-default) > li {
  list-style-type: none;
}

.categoria {
  text-align: left;
  max-height: 440px;
  max-width: 350px;
  overflow-y: auto;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  //Firefox
  scroll-behavior: auto;
  scrollbar-width: thin;
  // /Firefox
  li::before {
    content: "";
    position: absolute;
    left: 0px;
    top: 23px;
    width: 6px;
    height: 6px;
    background-color: #000;
  }
  li {
    position: relative;
    font-weight: 500;
    color: #77777b;
    padding-left: 15px;
    font-size: 11pt;
    margin-top: 25px;
    font-family: gotham;
  }
  li p {
    padding: 0;
  }
  ul {
    padding-left: 15px;
  }
}

@media (max-width: 480px) {
  .categoria {
    li {
      position: relative;
      cursor: pointer;
    }
    i {
      position: absolute;
      top: 0px;
    }
    .active {
      background-color: white;
    }
    .collapsible-body {
      padding-left: 30px;
    }
  }
}

::-webkit-scrollbar {
  width: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #d9dbdf;
}

.card-premio {
  position: relative;
  width: 260px;
  padding-right: 10px;
  padding-left: 10px;
  margin: auto;
  margin-bottom: 80px;
  cursor: pointer;
  .body {
    background-color: #eeecec;
    padding: 50px 5px 20px 5px;
    height: 300px;
  }
  .icon-pres {
    position: absolute;
    top: 10px;
    left: 20px;
    max-width: 55px;
    max-height: 55px;
  }
  .img-premio {
    max-width: 200px;
    display: block;
    margin: auto;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  .nome-premio {
    text-align: center;
    color: #777777;
    font-size: 12pt;
    padding: 0px 10px 0px 10px;
    min-height: 50px;
  }
  .pontos-premio {
    text-align: center;
    font-weight: 900;
  }
}

.btn-resgatar {
    background-color: #000;
    color: white;
    border-radius: 20px;
    padding: 5px 25px 5px 25px;
    display: table;
    margin-right: auto;
    margin-left: auto;
    border: 1px solid #000;
}

.btn-resgatar:hover {
    background-color: white;
    color: #000;
}

.collapsible,
.collapsible-header,
.collapsible-body,
.collapsible li,
li p {
  border: none;
  box-shadow: none;
  margin-top: 0;
}
</style>